/**
 * Security-related utilities for reading authentication and
 * organisation data from localStorage.
 */

/**
 * Returns the `organizationId` array stored in the `security` localStorage entry.
 * Falls back to an empty array when the entry is missing or unparseable.
 */
export const getOrganizationId = (): any[] => {
	const raw = localStorage.getItem('security');
	if (!raw) return [];
	try {
		return JSON.parse(raw).organizationId ?? [];
	} catch {
		return [];
	}
};
